import React, { createContext, useState, useEffect, useContext } from 'react';
import axiosClient from '../api/axiosClient';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lookups, setLookups] = useState(null);

  useEffect(() => {
    const initAuth = async () => {
      try {
        axiosClient.get('/lookups/all/bundle').then((lookupRes) => {
          if (lookupRes.data.success) setLookups(lookupRes.data.data);
        }).catch(() => { });

        const token = localStorage.getItem('accessToken');
        if (token) {
          const res = await axiosClient.get('/auth/me');
          if (res.data.success) {
            setUser(res.data.data.user);
            setProfile(res.data.data.profile);
          }
        }
      } catch (err) {
        console.error('Auth initialization error:', err);
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
      } finally {
        setLoading(false);
      }
    };

    initAuth();
  }, []);

  const login = async (email, password) => {
    const res = await axiosClient.post('/auth/login', { email, password });
    if (res.data.success) {
      localStorage.setItem('accessToken', res.data.data.accessToken);
      localStorage.setItem('refreshToken', res.data.data.refreshToken);
      setUser(res.data.data.user);
      setProfile(res.data.data.profile);
    }
    return res.data;
  };

  const register = async (userData) => {
    const res = await axiosClient.post('/auth/register', userData);
    return res.data;
  };

  const logout = async () => {
    try {
      await axiosClient.post('/auth/logout');
    } catch (e) {
    }
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    setUser(null);
    setProfile(null);
  };

  const refreshProfile = async () => {
    try {
      const res = await axiosClient.get('/auth/me');
      if (res.data.success) {
        setUser(res.data.data.user);
        setProfile(res.data.data.profile);
      }
    } catch (err) {
      console.error('Error refreshing profile:', err);
    }
  };

  const updateProfile = (partialUpdate) => {
    setProfile((prev) => (prev ? { ...prev, ...partialUpdate } : partialUpdate));
  };

  const loginWithToken = (token, refreshToken, userData, profileData) => {
    if (token) localStorage.setItem('accessToken', token);
    if (refreshToken) localStorage.setItem('refreshToken', refreshToken);
    if (userData) setUser(userData);
    if (profileData) setProfile(profileData);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        profile,
        lookups,
        loading,
        login,
        loginWithToken,
        register,
        logout,
        refreshProfile,
        updateProfile,
        isAuthenticated: !!user,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
